import { z } from "zod";

// in separate file to avoid circular dependency
export const ExploreCustomTimeUnit = z.object({
  // for now this is only custom time unit type, in the future we may have
  // offset time units, and it could be useful to distinguish this in the
  // explore spec
  type: z.literal("timespine"),
  name: z.string(),
});

export type ExploreCustomTimeUnit = z.infer<typeof ExploreCustomTimeUnit>;
